module.exports = __webpack_public_path__ + "img/ics_o_warning_triangles.9f88c472.svg";